$(function() {

     $('.header-cart .header__link').bind('click', function(e) {
        e.preventDefault();
        showRebuyCart();
     });

    $('.rebuy-show-cart-button').each(function(index, item) {
        item = $(item);
        
        item.bind('click', function(e) {
          e.preventDefault();
          showRebuyCart();
        });
        
        if (item.hasClass('auto-show')) {
          showRebuyCart();
        }
    });

    var redirectContainer = $('.cart-redirect-container');
    if (redirectContainer.length) {
        var url = redirectContainer.data('url');
        //console.log(url);
        window.location.href = url;
    }
});

var waitingForRebuyTimer = null;
var cartVisibleCheckTimer = null;

function showRebuyCart() {
      if (!(window.Rebuy && window.Rebuy.SmartCart)) {
        if (!waitingForRebuyTimer) {
          
          //console.log('waiting for rebuy to load...');
          
          waitingForRebuyTimer = setInterval(function() {
            showRebuyCart();
          }, 500);
        }
        return;
      }
      
      if (waitingForRebuyTimer) {
        
        //console.log('...rebuy loaded!');
        
        clearInterval(waitingForRebuyTimer);
        waitingForRebuyTimer = null;
      }
      
      //console.log('showing rebuy cart...')
      
      Rebuy.SmartCart.show(); // attempt to show
      
      if (cartVisibleCheckTimer) {
        clearTimeout(cartVisibleCheckTimer);
      }
      
      cartVisibleCheckTimer = setTimeout(function() {
        if (Rebuy.SmartCart.visible) {
          //console.log('...rebuy cart shown!');
        } else {
          //console.log('...cart not shown, trying again...');
          showRebuyCart();
        }
      }, 100);
}